'use client';

export default function NotFound() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <h1 style={{ fontSize: '1.5rem', color: '#475569' }}>404 — Page introuvable</h1>
    </div>
  );
}
